(function () {
	const testimonials = (isUpdate) => {
		const testimonialsSections = document.querySelectorAll('.testimonials-section');
		const cardsSliders = document.querySelectorAll('.testimonials__cards');
		const textSliders = document.querySelectorAll('.testimonials__slider');
		const prevArrows = document.querySelectorAll('.testimonials__button--prev');
		const nextArrows = document.querySelectorAll('.testimonials__button--next');
		const navigation = document.querySelectorAll('.testimonials__navigation');

		const initSliders = margin => {
			textSliders.forEach((slider, index) => {
				// MCA: per-section autoplay (slow carousel, pause on hover) read from
				// data attrs on the section wrapper. Cards follow via controller link.
				const sectionWrap = slider.closest('[data-testimonials-autoplay]');
				const autoplayOn = sectionWrap?.dataset.testimonialsAutoplay === 'true';
				const autoplayDelay = parseInt(sectionWrap?.dataset.testimonialsDelay, 10) || 6000;

				const textSlider = new Swiper(slider, {
					slidesPerView: 1,
					loop: true,
					loopedSlides: loopedSlides,
					simulateTouch: true,
					allowTouchMove: true,
					watchSlidesProgress: true,
					preventInteractionOnTransition: true,
					autoplay: autoplayOn ? {
						delay: autoplayDelay,
						disableOnInteraction: false,
						pauseOnMouseEnter: true,
					} : false,
					mousewheel: {
						forceToAxis: true,
					},
					navigation: {
						nextEl: nextArrows[index],
						prevEl: prevArrows[index],
					},
					pagination: {
						el: navigation[index],
						type: 'fraction',
					},
					createElements: true,
					effect: 'fade',
					fadeEffect: {
						crossFade: true,
					},
				})

				const cardSlider = new Swiper(cardsSliders[index], {
					slidesPerView: 1,
					loopedSlides: loopedSlides,
					loopedSlidesLimit: loopedSlides,
					loop: true,
					variableWidth: false,
					effect: 'creative',
					simulateTouch: true,
					allowTouchMove: true,
					watchSlidesProgress: true,
					preventInteractionOnTransition: true,
					mousewheel: {
						forceToAxis: true,
					},
					// MCA: single clean image per slide — neighbours fade out (no
					// peeking cluster). Aligned 2-column card layout.
					creativeEffect: {
						limitProgress: 1,
						prev: {
							opacity: 0,
							translate: ['-8%', 0, 0],
						},
						next: {
							opacity: 0,
							translate: ['8%', 0, 0],
						},
					},
				})

				cardSlider.controller.control = textSlider;
				textSlider.controller.control = cardSlider;

				if (isUpdate) {
					setTimeout(function () {
						cardSlider.update();
						textSlider.update();
					}, 800);
				}
			});
		}


		const testimonialsResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries;

			if (entry.contentRect.width < 991) {
				initSliders(40);
			} else if (entry.contentRect.width > 991) {
				initSliders(110);
			}
		});

		testimonialsSections.forEach(section => {
			testimonialsResizeObserver.observe(section);
		})

	};

	testimonials();

	document.addEventListener('shopify:section:load', function () {
		testimonials(true);
	});

})();
